import { render, staticRenderFns } from "./BuscadorMenuPlanes.vue?vue&type=template&id=654470e9&"
import script from "./BuscadorMenuPlanes.vue?vue&type=script&lang=js&"
export * from "./BuscadorMenuPlanes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports